import { render } from "./NcPage.vue?vue&type=template&id=74690f14&scoped=true"
import script from "./NcPage.vue?vue&type=script&lang=js"
export * from "./NcPage.vue?vue&type=script&lang=js"

import "./NcPage.vue?vue&type=style&index=0&id=74690f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74690f14"]])

export default __exports__